var map = {
	"./agua.jpg": 6358,
	"./aveioca.jpg": 9745,
	"./guia-almoco.jpg": 4470,
	"./guia-janta.jpg": 5343,
	"./lanche-noite.jpg": 2929,
	"./lanche-tarde-1.jpg": 9702,
	"./lanche-tarde-2.jpg": 7806,
	"./lanche-tarde-3.jpg": 3698,
	"./mix-castanhas-frutas-secas.jpg": 6042,
	"./mix-castanhas.jpg": 9193,
	"./panqueca-banana.jpg": 6335,
	"./panqueca.jpg": 3117,
	"./paozinho-frigideira.jpg": 6881,
	"./sanduiche.jpg": 3262,
	"./vitamina-chocolate-cacau.jpg": 7220,
	"./vitamina-frutas.jpg": 1042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6014;